import React, { FC, useState, useRef } from 'react';
import DashboardHeader from '../DashboardHeader/DashboardHeader';
import AppliedFilters from './AppliedFilters';
import '../../styles/css/dashboard.css';
import V3Table from './V3Table';
import ProgressBar from './ProgressBar';
import SpeakerSettingsModal from '../SpeakerSettings/SpeakerSettingsModal';
import { SummaryModal, SummaryModalRef } from '../SummaryModal/SummaryModal';
import { IModal, ModalVariantsEnums } from '../Editor/IEditor';
import { AnimatePresence } from 'framer-motion';
import { ResizableBox } from 'react-resizable';

const Viewer: FC = () => {
  const [modal, setModal] = useState<IModal>({ show: false, variant: ModalVariantsEnums.EXIT });
  const summaryModalRef = useRef<SummaryModalRef | null>(null);

  const handleModalClose = () => {
    if (summaryModalRef.current) {
      summaryModalRef.current.handleOnClose();
    }
  };

  return (
    <>
      <article style={{ backgroundColor: '#F7F7F7' }}>
        <DashboardHeader />
        <ProgressBar />
        <AppliedFilters />
        <V3Table modal={modal} setModal={setModal} />
      </article>
      <SpeakerSettingsModal />

      {/* Summary Modal */}
      <AnimatePresence>
        {modal.show && modal.variant === ModalVariantsEnums.SUMMARY && (
          <div
            className="modal_overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                handleModalClose();
              }
            }}
          >
            <ResizableBox
              style={{ backgroundColor: '#f2f2f2', padding: '30px' }}
              width={Math.floor(window.innerWidth * 0.8)}
              height={Math.floor(window.innerHeight * 0.8)}
            >
              <SummaryModal
                ref={summaryModalRef}
                onClose={() => setModal({ ...modal, show: false })}
                data={modal.data as string | { text: string; folderName: string }}
              />
            </ResizableBox>
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Viewer;
